import React from 'react'
import SmallTitle from '../small-title'
import * as styles from '../../styles/components/content-blocks/team.module.scss'
import { FillColor } from '../color-fill'
import { LinkedInIcon } from '../icons/social-icons'
import MailIcon from '../icons/mail'
import CaptionText from '../caption-text'
import ContentWrapper from '../content-wrapper'
import Heading from '../heading'
import cx from 'classnames'

export interface TeamMember {
    name: string
    title: string
    email?: string
    linkedIn?: string
    phone?: string
    image?: string
}

type ColorVariant = 'light' | 'dark'

export interface TeamBlockProps {
    heading?: string
    members: TeamMember[]
    backgroundType?: FillColor
    textColorVariant?: ColorVariant
}

const Member = ({ data }: { data: TeamMember}) => {
    return (
        <div className={styles.memberWrapper}>
            <div className={styles.memberContainer}>
                {data.image &&
                    <img
                        src={data.image}
                        alt={data.name}
                        className={styles.imageContainer}
                    />
                }
                <SmallTitle>{data.name}</SmallTitle>
                <CaptionText>{data.title}</CaptionText>
                <div className={styles.contactOptionsContainer}>
                    <a href={`mailto:${data.email}`} aria-label="Contact by email">
                        <MailIcon className={styles.mailIcon} />
                    </a>
                    {data?.linkedIn &&
                        <a href={data.linkedIn} aria-label="Contact on LinkedIn">
                            <LinkedInIcon />
                        </a>}
                </div>
                {data.phone}
            </div>
        </div>
    )
}

const TeamBlock = ({ heading, members, textColorVariant = 'dark', backgroundType = 'white' }: TeamBlockProps) => {
    return (
        <ContentWrapper color={backgroundType} className={cx(styles[textColorVariant])}>
            {heading && <Heading className={styles.heading}>{heading}</Heading> }
            <div className={styles.teamContainer}>
                {members.map((member) => <Member data={member} />)}
            </div>
        </ContentWrapper>
    )
}

export default TeamBlock
